/* TopupPacks — buy more JAI credits (web only).
 *
 * Two packs, one-off payment through Stripe Checkout. The browser sends only a
 * pack id; the server owns the price (billingController.startTopupCheckout).
 * Credits are added by the Stripe webhook after payment, and each purchase
 * expires one month after it is bought.
 *
 * Renders nothing on the native iOS app: nothing may be sold inside the app, and
 * the server refuses the request too. No emoji (UI chrome, Hard Rule 4).
 */

import { useState } from 'react'
import { billingApi } from '../services/api'
import { IS_NATIVE_APP } from '../services/runtime'
import { CREDIT_TOPUP_PACKS } from '../config/planAccess'
import { fmtPrice } from '../config/plans'
import { V2 } from './JaiV2'
import { JAI_FONTS } from './JaiBrand'

export default function TopupPacks({ signedIn = true, onNeedAccount }) {
  const [busy, setBusy] = useState('')
  const [error, setError] = useState('')

  if (IS_NATIVE_APP) return null

  const buy = async (pack) => {
    setError('')
    if (!signedIn) { onNeedAccount?.(); return }
    setBusy(pack.id)
    try {
      const { data } = await billingApi.startTopup(pack.id)
      window.location.assign(data.url) // hand off to Stripe
    } catch (err) {
      setError(err.response?.data?.error || 'Could not start checkout. Please try again.')
      setBusy('')
    }
  }

  return (
    <div style={{ fontFamily: JAI_FONTS.tight }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(190px, 1fr))', gap: 12 }}>
        {CREDIT_TOPUP_PACKS.map((pack) => (
          <button key={pack.id} type="button" onClick={() => buy(pack)} disabled={!!busy}
            style={{
              textAlign: 'left', background: 'white', border: `1.5px solid ${V2.blue}`, borderRadius: 12,
              padding: '14px 16px', cursor: busy ? 'default' : 'pointer', opacity: busy && busy !== pack.id ? 0.6 : 1,
              fontFamily: JAI_FONTS.tight,
            }}>
            <div style={{ fontSize: 16, fontWeight: 750, color: V2.navy }}>{pack.credits} credits</div>
            <div style={{ fontSize: 13, color: V2.mute, marginTop: 2 }}>
              {busy === pack.id ? 'Opening checkout...' : `${fmtPrice(pack.priceCents / 100)} one-off`}
            </div>
          </button>
        ))}
      </div>
      <p style={{ fontSize: 12, color: V2.faint, margin: '10px 0 0', lineHeight: 1.5 }}>
        Top-up credits are used after your monthly credits and expire 1 month after you buy them.
      </p>
      {error && <p role="alert" style={{ fontSize: 12.5, color: '#B42318', margin: '8px 0 0' }}>{error}</p>}
    </div>
  )
}
